import { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtDate } from "@/lib/dates";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ArrowRight } from "lucide-react";

const when = (iso) => {
  const d = new Date(iso);
  return `${fmtDate(d.toLocaleDateString("en-CA", { timeZone: "Pacific/Auckland" }))} ${d.toLocaleTimeString("en-NZ", { timeZone: "Pacific/Auckland", hour: "2-digit", minute: "2-digit" })}`;
};

export const RoleLogDialog = ({ open, onOpenChange }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (open) { api.get("/role-log").then((r) => setRows(r.data || [])).catch(() => {}); }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="role-log-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">Access Activity Log</DialogTitle>
          <DialogDescription>Every role change, newest first (NZ time).</DialogDescription>
        </DialogHeader>
        <ul className="divide-y divide-[#E5E0D8] border border-[#E5E0D8] rounded-xl">
          {rows.map((r) => (
            <li key={r.id} className="px-4 py-3" data-testid={`role-log-row-${r.id}`}>
              <div className="flex flex-wrap items-center gap-2 text-sm">
                <span className="font-semibold text-[#1C241B]">{r.target_name}</span>
                <span className="rounded bg-[#F1EFEA] px-2 py-0.5 text-xs text-[#526050]">{r.old_role}</span>
                <ArrowRight className="h-3.5 w-3.5 text-[#7A8A78]" />
                <span className="rounded bg-[#EAF2E8] px-2 py-0.5 text-xs font-semibold text-[#2D5A27]">{r.new_role}</span>
              </div>
              <p className="mt-1 text-xs text-[#7A8A78]">by {r.actor_name} · {when(r.at)} · {r.source}</p>
            </li>
          ))}
          {rows.length === 0 && <li className="px-4 py-8 text-center text-sm text-[#7A8A78]">No role changes recorded yet.</li>}
        </ul>
      </DialogContent>
    </Dialog>
  );
};
